import { useQuery } from '@tanstack/react-query';
import { getCoachAnalytics, type CoachAnalytics } from '@/services/edgeFunctionWrappers/coachAnalyticsWrapper';
import { useUserStore } from '@/store/userStore';

export function useCoachAnalytics(coachUserId: string | undefined, startDate: string, endDate: string) {
  const gymId = useUserStore((s) => s.gymId);
  return useQuery<CoachAnalytics>({
    queryKey: ['coach-analytics', coachUserId, gymId, startDate, endDate],
    enabled: !!coachUserId && !!gymId,
    staleTime: 60_000,
    queryFn: () =>
      getCoachAnalytics({
        coachId: coachUserId!,
        gymId: gymId!,
        startDate,
        endDate,
      }),
  });
}
